module.exports = __webpack_public_path__ + "media/japanese_school_bell.cd0b6457.mp3";